export { PatientDialogComponent as DialogComponent } from './components/patient-dialog.component';
export { PatientFormComponent as FormComponent } from './components/patient-form.component';
export { PatientMainComponent as MainComponent } from './components/patient-main.component';
